import React from "react";
//local
import {
  IconLinkOneDrive,
  IconLinkGoogleDrive,
  IconLinkDropbox,
  IconLinkByggnet,
  IconLinkBluebeam,
  IconLinkDox,
  IconLinkTreano,
  IconLinkInteraxo,
  IconLinkGeneric,
  IconLinkBjerking,
  IconLinkHmb,
  IconLinkBotrygg,
  IconLinkGbj,
  IconLinkOljibe,
  IconLinkMarkEnergiByggarna,
  IconLinkShbygg,
  IconLinkSveab,
  IconLinkNyab,
  IconLinkByggmastargruppen,
  IconLinkRocmore,
  IconLinkDalux,
  IconLinkYitsharepoint,
  IconLinkWebforum,
  IconLinkAvima,
  IconLinkInteroc,
  IconLinkIbinder,
  IconLinkSoderbyEntreprenad,
  IconDcWast,
  IconDocumentDalux,
  IconInbox,
  IconPlane,
  IconSheet,
  IconContract,
  IconCart,
  IconTruck,
} from "components/icons";
import {color} from "./color.consts";

export const emptySmartFormQuestion = {
  label: "",
  type: "boolean",
  required: true,
  min: null,
  max: null,
  maxlength: 255,
};

export const emptySmartFormHeadingQuestion = {
  label: "",
  type: "heading",
  required: false,
  min: null,
  max: null,
  maxlength: 255,
};

export const emptyRequest = {
  name: "",
  description: "",
  location: null,
  offersHidden: false,
  hardDateCloseOffers: false,
  reminders: true,
  reminderDays: [1, 3, 7, 14, 30],
  ContactPersonId: null,
  ProjectId: null,
  closedAt: null,
  standardAgreement: "",
  documents: [],
  recipients: {
    registered: [],
    notRegistered: [],
  },
  messages: [],
  smartFormQuestions: [],
  entrepreneurWithin: [],
  entrepreneurOffers: [],
  materialSupplierType: [],
  consultingServices: [],
};

export const emptyProject = {
  name: "",
  reference: "",
  DepartmentId: null,
  location: "",
  buyer: "",
  Members: [],
  availableIn: [],
  isPrivate: false,
};

export const emptyProcurement = {
  name: "",
  UserId: "",
};

export const emptyManualOffer = {
  organizationName: "",
  price: null,
  validUntil: null,
  notes: "",
  documents: [],
};

export const adjustmentSymbolsAndColors = {
  less: {
    symbol: "",
    color: color.black,
  },
  equally: {
    symbol: "\u00B1",
    color: color.lightGray,
  },
  more: {
    symbol: "+",
    color: color.black,
  },
};

export const budgetSymbolsAndColors = {
  less: {
    symbol: "-",
    color: color.green,
  },
  equally: {
    symbol: "\u00B1",
    color: color.green,
  },
  more: {
    symbol: "+",
    color: color.red,
  },
};

export const newProjectInfo = {
  name: "",
  location: "",
  buyer: "",
  reference: "",
};

export const extLinkDomains = [
  "google.com",
  "google.se",
  "system2.byggnet.com",
  "projekt.treano.se",
  "ix.interaxo.com",
  "werkab-my.sharepoint.com",
  "werkab.sharepoint.com",
  "htpprojekt.sharepoint.com", // Clara projekt
  "htpprojekt-my.sharepoint.com", // Clara projekt
  "husab.sharepoint.com",
  "husab-my.sharepoint.com",
  "byggentreprenoren-my.sharepoint.com",
  "byggentreprenoren.sharepoint.com",
  "bjerking.sharepoint.com",
  "bjerking-my.sharepoint.com",
  "hmbcon.sharepoint.com",
  "hmbcon-my.sharepoint.com",
  "botrygg.sharepoint.com",
  "gbjbyggab.sharepoint.com",
  "oljibe-my.sharepoint.com",
  "oljibe.sharepoint.com",
  "markenergibyggarna-my.sharepoint.com",
  "shbygg.sharepoint.com",
  "shbygg-my.sharepoint.com",
  "sveab-my.sharepoint.com",
  "sveab.sharepoint.com",
  "nyabgroup-my.sharepoint.com",
  "nyabgroup.sharepoint.com",
  "build.dalux.com",
  "yitgroup-my.sharepoint.com",
  "365veidekke.sharepoint.com",
  "webforum.com",
  "avima.app",
  "workspace.interoc.se",
  "interocab-my.sharepoint.com",
  "byggmastargrup787.sharepoint.com",
  "rocmoreab.onmicrosoft.com",
  "rocmoreab.sharepoint.com",
  "dcwast-my.sharepoint.com",
  "dropbox.com",
  "1drv.ms",
  "onedrive.com",
  "onedrive.live.com",
  "dox.se",
  "ibinder.com",
  "soderbyentreprenad-my.sharepoint.com",
  "soderbyentreprenad.sharepoint.com",
  "norrlandsindmontage.sharepoint.com",
  "norrlandsindmontage-my.sharepoint.com",
  "bluebeamstudio.se",
  "bluebeamstudio.de",
  "bluebeamstudio.co.uk",
  "studio.bluebeam.com",
  "daluxFile",
];

export const extLinkIcons = {
  "google.com": <IconLinkGoogleDrive />,
  "google.se": <IconLinkGoogleDrive />,
  "system2.byggnet.com": <IconLinkByggnet />,
  "projekt.treano.se": <IconLinkTreano />,
  "ix.interaxo.com": <IconLinkInteraxo />,
  "werkab-my.sharepoint.com": <IconLinkGeneric />,
  "werkab.sharepoint.com": <IconLinkGeneric />,
  "htpprojekt.sharepoint.com": <IconLinkGeneric />, // Clara projekt
  "htpprojekt-my.sharepoint.com": <IconLinkGeneric />, // Clara projekt
  "husab.sharepoint.com": <IconLinkGeneric />,
  "husab-my.sharepoint.com": <IconLinkGeneric />,
  "byggentreprenoren-my.sharepoint.com": <IconLinkGeneric />,
  "byggentreprenoren.sharepoint.com": <IconLinkGeneric />,
  "bjerking.sharepoint.com": <IconLinkBjerking />,
  "bjerking-my.sharepoint.com": <IconLinkBjerking />,
  "hmbcon.sharepoint.com": <IconLinkHmb />,
  "hmbcon-my.sharepoint.com": <IconLinkHmb />,
  "botrygg.sharepoint.com": <IconLinkBotrygg />,
  "gbjbyggab.sharepoint.com": <IconLinkGbj />,
  "oljibe-my.sharepoint.com": <IconLinkOljibe />,
  "oljibe.sharepoint.com": <IconLinkOljibe />,
  "markenergibyggarna-my.sharepoint.com": <IconLinkMarkEnergiByggarna />,
  "shbygg.sharepoint.com": <IconLinkShbygg />,
  "shbygg-my.sharepoint.com": <IconLinkShbygg />,
  "sveab-my.sharepoint.com": <IconLinkSveab />,
  "sveab.sharepoint.com": <IconLinkSveab />,
  "nyabgroup-my.sharepoint.com": <IconLinkNyab />,
  "nyabgroup.sharepoint.com": <IconLinkNyab />,
  "byggmastargrup787.sharepoint.com": <IconLinkByggmastargruppen />,
  "rocmoreab.onmicrosoft.com": <IconLinkRocmore />,
  "rocmoreab.sharepoint.com": <IconLinkRocmore />,
  "build.dalux.com": <IconLinkDalux />,
  "yitgroup-my.sharepoint.com": <IconLinkYitsharepoint />,
  "365veidekke.sharepoint.com": <IconLinkGeneric />,
  "webforum.com": <IconLinkWebforum />,
  "avima.app": <IconLinkAvima />,
  "workspace.interoc.se": <IconLinkInteroc />,
  "interocab-my.sharepoint.com": <IconLinkInteroc />,
  "dcwast-my.sharepoint.com": <IconDcWast />,
  "dropbox.com": <IconLinkDropbox />,
  "1drv.ms": <IconLinkOneDrive />,
  "onedrive.com": <IconLinkOneDrive />,
  "onedrive.live.com": <IconLinkOneDrive />,
  "dox.se": <IconLinkDox />,
  "ibinder.com": <IconLinkIbinder />,
  "soderbyentreprenad-my.sharepoint.com": <IconLinkSoderbyEntreprenad />,
  "soderbyentreprenad.sharepoint.com": <IconLinkSoderbyEntreprenad />,
  "bluebeamstudio.se": <IconLinkBluebeam />,
  "bluebeamstudio.de": <IconLinkBluebeam />,
  "bluebeamstudio.co.uk": <IconLinkBluebeam />,
  "studio.bluebeam.com": <IconLinkBluebeam />,
  "norrlandsindmontage.sharepoint.com": <IconLinkGeneric />,
  "norrlandsindmontage-my.sharepoint.com": <IconLinkGeneric />,
  daluxFile: <IconDocumentDalux />,
};

export const rfpStatuses = {
  DRAFT: "DRAFT",
  PUBLISHED: "PUBLISHED",
  REMOVED: "REMOVED",
  STOPPED: "STOPPED",
};

export const STANDARD_AGREEMENT_TYPES = Object.freeze({
  NO_STANDARD_AGREEMENT: "NO_STANDARD_AGREEMENT",
  OTHER_AGREEMENT: "OTHER_AGREEMENT",
});

export const procurementStatuses = {
  SELECT_STATUS: "PROJECT_ITEM_STATUS_SELECT_STATUS",
  NO_STATUS: "PROJECT_ITEM_STATUS_NO_STATUS",
  RFP_DRAFT: "PROJECT_ITEM_STATUS_RFP_DRAFT",
  RFP_OUT: "PROJECT_ITEM_STATUS_RFP_OUT",
  OFFERS_IN: "PROJECT_ITEM_STATUS_OFFERS_IN",
  EVALUATING: "PROJECT_ITEM_STATUS_EVALUATING",
  CONTRACT_DRAFT: "PROJECT_ITEM_STATUS_CONTRACT_DRAFT",
  CONTRACT: "PROJECT_ITEM_STATUS_CONTRACT",
  STOPPED: "PROJECT_ITEM_STATUS_STOPPED",
};

export const contractType = {
  RFT: "CONTRACT_TYPE_RFT",
  UPLOADED: "CONTRACT_TYPE_UPLOADED",
  HANDYSIGN: "CONTRACT_TYPE_HANDYSIGN",
};

export const contractStatus = {
  RFT_COMPLETED: "CONTRACT_TYPE_RFT_COMPLETED",
  RFT_PENDING: "CONTRACT_TYPE_RFT_PENDING",
  UPLOADED: "CONTRACT_TYPE_UPLOADED",
  HANDYSIGN: "CONTRACT_TYPE_HANDYSIGN",
};

export const sortContractsSelectItems = [
  {label: "CONTRACT_SORT_SELECT_UPDATEDAT_ASC", value: "updatedAt|ASC"},
  {label: "CONTRACT_SORT_SELECT_UPDATEDAT_DESC", value: "updatedAt|DESC"},
  {label: "CONTRACT_SORT_SELET_NAME_ASC", value: "name|ASC"},
  {label: "CONTRACT_SORT_SELET_NAME_DESC", value: "name|DESC"},
  {label: "CONTRACT_SORT_SELECT_NUMBER_ASC", value: "number|ASC"},
  {label: "CONTRACT_SORT_SELECT_NUMBER_DESC", value: "number|DESC"},
  {label: "CONTRACT_SORT_SELECT_SUPPLIER_ASC", value: "supplier|ASC"},
  {label: "CONTRACT_SORT_SELECT_SUPPLIER_DESC", value: "supplier|DESC"},
];

export const acceptableStatuses = [
  // (Create RFP): Must be at least RFP_DRAFT
  [
    procurementStatuses.RFP_DRAFT,
    procurementStatuses.RFP_OUT,
    procurementStatuses.OFFERS_IN,
    procurementStatuses.EVALUATING,
    procurementStatuses.CONTRACT_DRAFT,
    procurementStatuses.CONTRACT,
  ],
  // (Publish RFP): Must be at least RFP_OUT
  [
    procurementStatuses.RFP_OUT,
    procurementStatuses.OFFERS_IN,
    procurementStatuses.EVALUATING,
    procurementStatuses.CONTRACT_DRAFT,
    procurementStatuses.CONTRACT,
  ],
  // (Tender received): Must be at least OFFERS_IN
  [
    procurementStatuses.OFFERS_IN,
    procurementStatuses.EVALUATING,
    procurementStatuses.CONTRACT_DRAFT,
    procurementStatuses.CONTRACT,
  ],

  // (Contract Ready): Must be at least CONTRACT
  [procurementStatuses.CONTRACT],
];

export const noOffice = "no_office";

export const noOfficeItem = {label: "SELECT_NO_DEPARTMENT", value: noOffice};
export const allOfficesItem = {label: "SELECT_ALL_DEPARTMENTS", value: null};

export const sortProcurementsSelectItems = [
  {label: "PROCUREMENT_SORT_SELECT_NAME", value: "name"},
  {label: "PROCUREMENT_SORT_SELECT_DATE", value: "createdAt"},
  {label: "PROCUREMENT_SORT_SELECT_TIME", value: "closedAt"},
  {label: "PROCUREMENT_SORT_ACCOUNT", value: "account"},
];

export const bulkProcurementOperations = {
  PROCUREMENT_BULK_OPERATION_MESSAGE_TO_ALL: "PROCUREMENT_RFT_MESSAGE_TO_ALL",
  PROCUREMENT_BULK_OPERATION_UPDATE_CLOSED_AT: "PROCUREMENT_RFT_UPDATE_CLOSED_AT",
  PROCUREMENT_BULK_OPERATION_CREATE_REVISION: "PROCUREMENT_RFT_CREATE_REVISION",
  PROCUREMENT_BULK_OPERATION_EXPORT_TO_NEXT: "PROCUREMENT_RFT_EXPORT_TO_NEXT",
};

export const medalRating = {
  MEDAL_GOLD: "MEDAL_GOLD",
  MEDAL_SILVER: "MEDAL_SILVER",
  MEDAL_BRONZE: "MEDAL_BRONZE",
};

export const offerMedalRating = {
  [medalRating.MEDAL_GOLD]: "OFFER_MEDAL_GOLD",
  [medalRating.MEDAL_SILVER]: "OFFER_MEDAL_SILVER",
  [medalRating.MEDAL_BRONZE]: "OFFER_MEDAL_BRONZE",
};

export const offerToMedalRating = {
  OFFER_MEDAL_GOLD: medalRating.MEDAL_GOLD,
  OFFER_MEDAL_SILVER: medalRating.MEDAL_SILVER,
  OFFER_MEDAL_BRONZE: medalRating.MEDAL_BRONZE,
};

export const daluxFolderType = {
  FOLDER: "FOLDER",
  VERSION_SET: "VERSION_SET",
};

export const initialOrganizationRoleMembers = {
  owner: [],
  admin: [],
  member: [],
};

export const projectDatesSteps = [
  {
    key: "timelineCreateRftDate",
    icon: <IconSheet color={color.white} />,
    tooltip: "PROCUREMENTS_DATES_TAB_HEAD_ICON_CREATE_RFP",
    titleColor: "blue",
  },
  {
    key: "timelinePublishRftDate",
    icon: <IconPlane color={color.white} />,
    tooltip: "PROCUREMENTS_DATES_TAB_HEAD_ICON_PUBLISH_RFP",
    titleColor: "green",
  },
  {
    key: "timelineReceiveTendersDate",
    icon: <IconInbox color={color.white} />,
    tooltip: "PROCUREMENTS_DATES_TAB_HEAD_ICON_RECEIVE_TENDERS",
    titleColor: "green",
  },
  {
    key: "timelineContractReadyDate",
    icon: <IconContract color={color.white} />,
    tooltip: "PROCUREMENTS_DATES_TAB_HEAD_ICON_CONTRACT_READY",
    titleColor: "black",
  },
  {
    key: "timelinePlaceOrderDate",
    icon: <IconCart color={color.black} />,
    tooltip: "PROCUREMENTS_DATES_TAB_HEAD_ICON_PLACE_ORDER",
    titleColor: "white",
  },
  {
    key: "timelineDeliveryDate",
    icon: <IconTruck color={color.black} />,
    tooltip: "PROCUREMENTS_DATES_TAB_HEAD_ICON_DELIVERY",
    titleColor: "white",
  },
];

export const rfpContractRevisionName = "RFP_FOR_CONTRACT_REVISION_NAME";

export const revisionDocuments = {
  contracts: [],
  documents: [],
  plans: [],
  links: [],
};
